import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class OrganizacionService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'organizacion'].join('/');
  }


  public getAll2() {
    return this.http
    .get([this.ApiUrl,'getall2'].join('/'))
    .map(res => res.json());
  }

  public getOrgaProyecto() {
    return this.http
    .get([this.ApiUrl, 'getorgaproyecto'].join('/'))
    .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/organizacion/organizacion.service.ts